<template>
  <div>
    <timeline
      ref="timeline"
      :items="timeline.items"
      :groups="timeline.groups"
      :options="timeline.options"
      @click="clicked"
    >
    </timeline>
    <p><span v-html="stepMessage"></span></p>
  </div>
</template>

<script>
import { Timeline } from 'vue2vis'
import '../../../node_modules/vue2vis/dist/vue2vis.css'

export default {
  props: ['applicationHistory'],
  components: {
    Timeline,
  },
  data() {
    return {
      stepMessage: '',
    }
  },
  methods: {
    clicked(val) {
      this.stepMessage =
        val.item !== null
          ? this.timeline.items.find(step => step.id === val.item).title
          : ''
    },
  },
  computed: {
    // precheckerComment () {
    //   let comment = this.applicationHistory.slice(0).reverse().find(step => step.group === 2)
    //   return comment && comment.title
    // },
    timeline() {
      return {
        groups: [
          { id: 0, content: this.$i18n.t('applicant') },
          { id: 1, content: this.$i18n.t('waiting') },
          { id: 2, content: this.$i18n.t('prechecking') },
          { id: 3, content: this.$i18n.t('president') },
          { id: 4, content: this.$i18n.t('proponent') },
          { id: 5, content: this.$i18n.t('executive') },
          { id: 6, content: this.$i18n.t('consultant') },
          { id: 7, content: this.$i18n.t('viceA') },
          { id: 8, content: this.$i18n.t('viceB') },
          { id: 9, content: this.$i18n.t('process_viewer') },
          { id: 10, content: this.$i18n.t('print') },
          { id: 11, content: this.$i18n.t('reappraisal_board') },
          { id: 12, content: this.$i18n.t('academic_director') },
        ],
        items: this.applicationHistory, // [
        options: {
          editable: false,
          zoomMax: 100000000000,
          zoomMin: 100000009,
          tooltip: {
            overflowMethod: 'cap',
            followMouse: true
          }
        },
      }
    },
    historySteps() {
      return this.applicationHistory.length
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../node_modules/vue2vis/dist/vue2vis.css';
</style>
